export default __webpack_public_path__ + "static/media/GammaTable3Img.0fe770be.jpg";